module.exports = __webpack_public_path__ + "static/media/vc.475f7d86.svg";